import type { MouseEvent } from 'react';

// Heuristic used by the readonly form: a click on an interactive-looking
// descendant (input/button/textarea/select) switches the page into edit mode.
export const shouldEnterEditModeOnClick = (e: MouseEvent, readonly: boolean): boolean => {
  // Clicks inside the form always land on an element; reading it as an input covers `type`.
  const target = e.target as HTMLInputElement;

  if (
    !readonly ||
    target.parentElement.id === 'configuration-page-form' ||
    target.parentElement.role === 'tabpanel' ||
    target.type === 'checkbox'
  ) {
    return false;
  }

  const tagName = target.tagName.toLowerCase();
  const isInput = ['input', 'button', 'textarea'].includes(tagName);
  const isSelect = target.querySelectorAll('[class*="select"]').length > 0;
  const hasButtons = target.querySelectorAll('button').length > 0;

  return isInput || isSelect || hasButtons;
};
